import { useOpenOrdersView } from '#/features/perpetuals/trade-overview/open-orders-context';
import TabLabel, { Badge } from './TabLabel';

export default function TabLabelOpenOrders() {
  const { openOrders } = useOpenOrdersView();

  return (
    <TabLabel>
      Open Orders <Badge>{openOrders.length}</Badge>
    </TabLabel>
  );
}
